import { reactive } from 'vue'

export function useIrregularityDialog () {
  const state = reactive({
    isOpen: false,
    title: '',
    editId: null,
    description: null,
    // Mirrors the backend's boolean `is_active`; null while creating, since a new
    // record has no state to carry over yet.
    isActive: null
  })

  const open = (config) => {
    const { title, editId, description, isActive } = config || {}
    state.title = title || ''
    state.editId = editId || null
    state.description = description || null
    state.isActive = typeof isActive === 'boolean' ? isActive : null
    state.isOpen = true
  }

  const close = () => {
    state.title = ''
    state.editId = null
    state.description = null
    state.isActive = null
    state.isOpen = false
  }

  return {
    state,
    open,
    close
  }
}
